export const PRODUCT_VARIANT_LIST_TYPE = {
  PRODUCTS: 'products',
  SEARCH: 'search',
  SERVICES: 'services',
  SEARCH_SERVICES: 'search-services',
};
